const formFiles = document.querySelectorAll(".form-files");

if (formFiles.length) {
    formFiles.forEach(formFile => {
        const input = formFile.querySelector("input");
        const description = formFile.querySelector(".form-files__ui-description");

        input.addEventListener("input", (e) => {
            const {files} = e.target;

            if (!files.length) {
                description.textContent = description.getAttribute("data-default-text");
                formFile.classList.remove("-active");
            } else {
                description.textContent = Array.from(files).map(file => file.name).join(", ");
                formFile.classList.add("-active");
            }
        })
    });
}